export default {
  id: 'ChangeSchool',
  code: 'CN',
  text: {
    'My Schools': '我的学校',
    'Principal': '校长',
    "Teacher": '老师',
    'Create New School': '创建新学校',
    '$79 USD / month per school': '每学校每个月 $79 USD',
    "Delete School": '删除学校',
    'Confirm': '确认',
    'Decline': '拒绝',
    'Accept': '接受',
    'Proceed to delete school?': '确认删除学校？',
    'Proceed to decline the invitation?': '确认拒绝邀请吗？',
    'Proceed to accept the invitation?': '确认接受邀请吗？',
    'Delete': '删除',
    'Are you sure you want to delete school? This process cannot be undone.': '您确认要删除学校吗？这个操作无法撤回。',
    'You are about go over the school limit, please upgrade to higher subscription plan to add more schools': '您已超出现计划包含的学校上限，请先升级至更高计划再创建更多学校。',
    'Upgrade Subscription Plan': '需要升级计划',
    'Your free trial is over, please subscribe to one of the plan for further usage, thank you!': '您的试用期已结束, 请订阅我们的服务计划后继续使用, 谢谢!',
    "This school's free trial is over, please inform the school owner to subscribe one of the plan for further usage, thank you!": '此学校的试用期已结束, 请通知学校校长订阅服务计划后继续使用, 谢谢!',
    "Your account is no longer active, please update your payment credit card info for further usage, thank you!": '您的订阅服务已到期, 请更新您的付款信用卡信息后继续使用, 谢谢!',
    "This school's account is no longer active, please contact the school's owner, thank you!": '此学校的订阅服务已到期, 请联系学校校长, 谢谢!',
    'You have used the free trial': '您已经使用过体验版'
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/ChangeSchool/locale.js